import * as React from 'react';
import { SearchInput } from 'react-admin';
import { useTranslate } from 'ra-core';
export function ListArrayInputFilter(props) {
    const { filter, setFilter } = props;
    const translate = useTranslate();
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchInput, { source: "q", onChange: event => { var _a; return setFilter(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || ''); }, placeholder: translate('resources.applications.actions.searchByApiTitle') })));
}
//# sourceMappingURL=ListArrayInputFilter.js.map